import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
`;
